export const AUTOMATIONS_BOARD_UNREADABLE_PLACEHOLDER_FF = 'automations_board_unreadable_placeholder';
